<template>
  <f7-page id="reg-myinfo-email-password" name="reg-myinfo-email-password" @page:afterin="afterin">
      <f7-navbar class="view-mobile no-border">
          <f7-nav-left class="back-button">
              <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
      </f7-navbar>

      <div class="block">

        <div class="fs-24 fw-bold">{{ $t('regis-enter-email-pass') }}</div>

        <div class="mt-20">
          <transition name="fade">
            <f7-card
                class   ="alert alert-danger mb-md"
                v-show  ="alertCard.show"
            >
                <div v-html="alertCard.title" slot="header"></div>
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i> 
            </f7-card>
          </transition>

          <MyInfoRegisterEmail
            :key="key.email"
            @validateInput="validateInput"
            @validateNextButton="validateNextButton"
          />

          <MyInfoRegisterPassword1
            :key="key.password1"
            @setPassword1="setPassword1"
            @showHidePassword="showHidePassword"
            @validateInput="validateInput"
            @validateNextButton="validateNextButton"
            :singpassPasswordInputType="singpassPasswordInputType"
          />

          <MyInfoRegisterPassword2
            :key="key.password2"
            @setPassword2="setPassword2"
            @showHidePassword="showHidePassword"
            @validateInput="validateInput"
            @validateNextButton="validateNextButton"
            :singpassPassword2InputType="singpassPassword2InputType"
          />
        </div>

        <f7-button round large fill @click="goToNextPage()" class="mt-5 view-desktop" :disabled="!isNextButtonValid">{{$t('general-btn-submit')}}</f7-button>
      </div>

      <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">        
        <f7-button large fill @click="goToNextPage()" :disabled="false">
            {{$t('general-btn-submit')}}
        </f7-button>
      </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import ApiService from "../../services/api-main";
  import CryptoAES from 'aes-ecb'
  import store from '../../store'
  import { check } from '@/plugins/helper';

  import MyInfoRegisterEmail from '../../components/myinfo-register-email.vue';
  import MyInfoRegisterPassword1 from '../../components/myinfo-register-password-1.vue';
  import MyInfoRegisterPassword2 from '../../components/myinfo-register-password-2.vue';

  export default {
    mounted (){
      if(this.email != ""){
        this.validateInput({name: "singpassEmail", value: this.email})
      }

      // RE-RENDER Passwords component
      this.key.password1 += 1
      this.key.password2 += 1
    },
    data() {
      return {
        isNextButtonValid     : false,
        singpassPassword      : "",
        singpassPassword2     : "",
        singpassPasswordInputType     : "password",
        singpassPassword2InputType    : "password",
        isSingpassEmailValid          : false,
        isSingpassPasswordValid       : false,
        isSingpassPassword2Valid      : false,
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        key:  {
            email                 : 0,
            password1             : 1000,
            password2             : 2000
        }
      };
    },
    methods: {
      ...mapActions('customer', []),
      ...mapActions('registration', []),
      ...mapActions('myinfo', ['setEmail']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      setPassword1(val){
        this.singpassPassword = val
      },

      setPassword2(val){
        this.singpassPassword2 = val
      },

      async goToNextPage(){
        this.showPreloader();
        if(this.finalValidation()){
          //this.$f7router.navigate("/register-mobile-no");

          const randVal = await ApiService.getRandomValue();

          this.recaptcha = "";
          var recaptchaData = store.state.registration;
          recaptchaData.recaptcha = "";

          var secretKey = process.env.VUE_APP_PSSTK+randVal;

          var encryptedPassword = CryptoAES.encrypt(secretKey, this.singpassPassword);
          var encryptedPassword2 = CryptoAES.encrypt(secretKey, this.singpassPassword2);

          var registrationData = store.state.registration;
          registrationData.email = this.email;
          registrationData.password = encryptedPassword;
          registrationData.password2 = encryptedPassword2;
          registrationData.isSingpass = true;

          const reqToken = await this.$api.registration.getToken(registrationData);

          if(reqToken.status == "WN00103"){
            this.$f7router.navigate("/register-mobile-no");
            this.hidePreloader();
          }else if(reqToken.status == "WN00101"){ // error recaptcha
            console.log("ERROR RECAPTCHA -> display V2")
            /*let $$ = this.Dom7;
            $$("#reg-slide-captcha-container").hide();
            this.isShowRecaptchaV2 = true;
            this.validateNextButton();
            */
            this.hidePreloader();
          }else if(reqToken.status == "WN00102"){ // email exist
            this.showAlert(true, this.$t('regis-email-exist'));
            this.hidePreloader();
          }else{ // GENERAL EXCEPTION
            //this.showAlert(true, reqToken.status)
            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqToken.status);
            this.hidePreloader();
          }
        }else{
          this.hidePreloader();
        }
      },

      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },

      showHidePassword(el){
        let $$ = this.Dom7;

        if(el == "singpassPassword"){
          if(this.singpassPasswordInputType == "password"){
            this.singpassPasswordInputType = "text";
            $$("#singpass-password-icon").html('<i class="f7-icons">eye</i>');
          }else{
            this.singpassPasswordInputType = "password";
            $$("#singpass-password-icon").html('<i class="f7-icons">eye_slash</i>');
          }

        } else if(el == "singpassPassword2"){
          if(this.singpassPassword2InputType == "password"){
            this.singpassPassword2InputType = "text";
            $$("#singpass-password-icon2").html('<i class="f7-icons">eye</i>');
          }else{
            this.singpassPassword2InputType = "password";
            $$("#singpass-password-icon2").html('<i class="f7-icons">eye_slash</i>');
          }
        }
      },

      validateInput(e) {
        let elName = "";
        if(e.name == "singpassEmail"){
          elName = "email"
        }else if(e.name == "singpassPassword"){
          elName = "password"
        }else{
          elName = "password2"
        }
        var inputName   = e.name;
        var inputValue  = "";
        var keyName     = "regis-"+elName;
        var translation;

        if(e.name == "singpassEmail"){
          this.$store.state.registration.singpassEmail = e.value
          inputValue = this.singpassEmail;
        }else if(e.name == "singpassPassword"){
          inputValue = this.singpassPassword;
        }else{
          inputValue = this.singpassPassword2;
        }

        if (inputValue.trim() == ""){
          translation = keyName + "-empty";
          this.setInputState(inputName, this.$t(translation));
          return false;
        }

        var validate = false;
        if (inputName == "singpassEmail"){
          validate   = check.validPattern("email", e.value);
        } else if(inputName == "singpassPassword" || inputName == "singpassPassword2"){
          validate   = check.validPattern("password", e.value);
        }

        if(!validate){
          translation = keyName + "-rule";
          this.setInputState(inputName, this.$t(translation));
          if(inputName == "singpassEmail"){
            this.isSingpassEmailValid = false;
          }else if(inputName == "singpassPassword"){
            this.isSingpassPasswordValid = false;
          }else if(inputName == "singpassPassword2"){
            this.isSingpassPassword2Valid = false;
          }
          this.isNextButtonValid = false;
          return false;
        }

        if(inputName == "singpassEmail"){
          this.isSingpassEmailValid = true;
        }else if(inputName == "singpassPassword"){
          this.isSingpassPasswordValid = true;
        }else if(inputName == "singpassPassword2"){
          this.isSingpassPassword2Valid = true;
        }

        if (inputName == "singpassPassword"){
            if(this.singpassPassword2.trim() != ""){
                if( this.singpassPassword != this.singpassPassword2){
                  translation = keyName + "2-mismatch";
                  this.setInputState("singpassPassword2", this.$t(translation));
                  this.isSingpassPassword2Valid = false;
                  this.isNextButtonValid = false;

                  if(validate){
                      this.isSingpassPasswordValid = true;
                      this.setInputState("singpassPassword", true);
                  }
                  return false;
                }else{
                  this.isSingpassPasswordValid = true;
                  this.isSingpassPassword2Valid = true;
                  this.setInputState("singpassPassword", true);
                  this.setInputState("singpassPassword2", true);
                }
            }
        }


        if (inputName == "singpassPassword2"){
          if( this.password != this.password2){
            translation = keyName + "-mismatch";
            this.setInputState(inputName, this.$t(translation));
            this.isSingpassPasswordValid = false;
            this.isSingpassPassword2Valid = false;
            this.isNextButtonValid = false;
            return false;
          }else{
            this.isSingpassPasswordValid = true;
            this.isSingpassPassword2Valid = true;
          }
        }

        this.setInputState(inputName, true);
        return true;
      },

      validateNextButton(){
        this.isNextButtonValid = this.isSingpassEmailValid && this.isSingpassPasswordValid && this.isSingpassPassword2Valid
      },

      finalValidation(){
        if(this.singpassPassword2.trim() != "" && (this.singpassPassword != this.singpassPassword2)){
          this.setInputState("singpassPassword2", this.$t("regis-password2-mismatch"));
          return false;
        }
        return true;
      },

      forceRerender() {
        let $$ = this.Dom7;
        $$("#slide-captcha-container").show();
        this.isShowRecaptchaV2 = false;
        this.isRenderCaptcha = true;
        this.componentKey += 1;
      },

      backButton() {
          switch(this.routerTo) {
              default          : this.$f7router.navigate("/register-personalise-account"); break;
          }
      },
     
    },
    components: {
      MyInfoRegisterEmail,
      MyInfoRegisterPassword1,
      MyInfoRegisterPassword2,
    },
    computed: {
      ...mapGetters('registration', [
        'singpassEmail',
      ]),
      ...mapGetters('myinfo', [
        'email',
      ])
    },
  }
</script>